<article class="entity-primary-details">
  <div class="section-header">
    <h4 class="descriptor h4">Affected Entity</h4>

    <div class="section-header-title-section">
      <div style="width: 100%">
        <div class="logo-wrapper">
          @if (this.incidentsPageStore.incident()!.entity?.logo) {
            <img
              [src]="this.incidentsPageStore.incident()!.entity?.logo"
              [alt]="this.incidentsPageStore.incident()!.entity?.name"
            />
          }
        </div>
        <div class="entity-title-buttons-and-description">
          <div class="entity-title-and-buttons">
            <h1 class="title h1-medium">
              {{ this.incidentsPageStore.incident()!.entity?.name ?? 'No DnB-Entity found' }}
            </h1>
            @if (this.incidentsPageStore.isEditMode()) {
              <div class="section-header-action-buttons">
                <button
                  class="entity-remove-button button-secondary-icon"
                  mat-icon-button
                  disableRipple
                  [disabled]="!this.incidentsPageStore.incident()!.entity"
                  (click)="onRemoveEntity()"
                >
                  <mat-icon>delete</mat-icon>
                </button>
                <button class="button-secondary" mat-flat-button extended (click)="openEntityEdit()">
                  Change entity
                </button>
              </div>
            }
          </div>
          <p class="body-medium">{{ this.incidentsPageStore.incident()!.entity?.description }}</p>
        </div>
      </div>
    </div>
  </div>

  <div class="cards-container">
    <mat-card class="mat-card section-info-card">
      <mat-card-title>Business / Professional Services</mat-card-title>
      <mat-card-content>{{
        businessSectorHR[this.incidentsPageStore.incident()!.entity?.businessSector || '-'] || '-'
      }}</mat-card-content>
    </mat-card>

    <mat-card class="mat-card section-info-card">
      <mat-card-title>Home country</mat-card-title>
      <mat-card-content
        ><span class="country-flag">{{
          CountryFlags[this.incidentsPageStore.incident()!.entity?.countryCode || 'Unknown']
        }}</span
        >{{ CountryDescriptor[this.incidentsPageStore.incident()!.entity?.countryCode || 'Unknown'] }}</mat-card-content
      >
    </mat-card>

    <mat-card class="mat-card section-info-card">
      <mat-card-title>Website</mat-card-title>
      <mat-card-content>
        @if (this.incidentsPageStore.incident()!.entity?.website) {
          @if (this.incidentsPageStore.incident()!.entity?.website) {
            <a
              class="link"
              href="https://{{ this.incidentsPageStore.incident()!.entity?.website }}"
              target="_blank"
              rel="noopener"
              >{{ this.incidentsPageStore.incident()!.entity?.website }}</a
            >
          }
        } @else {
          -
        }
      </mat-card-content>
    </mat-card>

    <mat-card class="mat-card section-info-card">
      <mat-card-title>Size</mat-card-title>
      <mat-card-content>
        {{ entitySizeHR[this.incidentsPageStore.incident()!.entity?.entitySize || '-'] || '-' }}
        @if (entitySizeThreshold[this.incidentsPageStore.incident()!.entity?.entitySize || '-']) {
          - {{ entitySizeThreshold[this.incidentsPageStore.incident()!.entity?.entitySize || '-'] || '' }}
        }
      </mat-card-content>
    </mat-card>

    <mat-card class="mat-card section-info-card">
      <mat-card-title>Entity Type</mat-card-title>
      <mat-card-content>{{ this.incidentsPageStore.incident()!.entity?.entityType || '-' }}</mat-card-content>
    </mat-card>

    <mat-card class="mat-card section-info-card">
      <mat-card-title>Revenue</mat-card-title>
      <mat-card-content>{{
        getFormattedRevenue(this.incidentsPageStore.incident()!.entity?.revenue)
      }}</mat-card-content>
    </mat-card>

    <mat-card class="mat-card section-info-card">
      <mat-card-title>Number Of Employees</mat-card-title>
      <mat-card-content>{{
        noOfEmployeesHR[this.incidentsPageStore.incident()!.entity?.numberOfEmployees ?? '-'] || '-'
      }}</mat-card-content>
    </mat-card>

    <mat-card class="mat-card section-info-card">
      <mat-card-title>Headquarter Address</mat-card-title>
      <mat-card-content>{{ this.incidentsPageStore.incident()!.entity?.headquarterAddress || '-' }}</mat-card-content>
    </mat-card>

    <mat-card class="mat-card section-info-card">
      <mat-card-title>Dun & Bradstreet</mat-card-title>
      <mat-card-content>{{ this.incidentsPageStore.incident()!.entity?.dnbId || '-' }}</mat-card-content>
    </mat-card>
  </div>
</article>
